<template>
  <div>
    <el-card>
      <div style="margin-bottom: 15px">
        <el-button type="primary" @click="handleAdd">新增规则</el-button>
      </div>
      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="ruleName" label="规则名称" width="150"></el-table-column>
        <el-table-column label="帖子类型" width="120">
          <template slot-scope="{ row }">
            <el-tag :type="row.postType === 'SUPPLY' ? 'danger' : 'warning'" size="small">
              {{ row.postType === 'SUPPLY' ? '供给' : '需求' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="费用(元)" width="100">
          <template slot-scope="{ row }">{{ (row.priceAmount / 100).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleEdit(row)">编辑</el-button>
            <el-button type="text" style="color: #F56C6C" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 20px; text-align: right"
        :current-page="query.page"
        :page-sizes="[10, 20, 50]"
        :page-size="query.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next"
        @size-change="val => { query.pageSize = val; fetchList() }"
        @current-change="val => { query.page = val; fetchList() }"
      ></el-pagination>
    </el-card>

    <el-dialog :title="isEdit ? '编辑规则' : '新增规则'" :visible.sync="dialogVisible" width="500px">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="规则名称" prop="ruleName">
          <el-input v-model="form.ruleName"></el-input>
        </el-form-item>
        <el-form-item label="帖子类型" prop="postType">
          <el-select v-model="form.postType" placeholder="请选择" style="width: 100%">
            <el-option label="供给" value="SUPPLY"></el-option>
            <el-option label="需求" value="DEMAND"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="费用(元)" prop="priceAmountYuan">
          <el-input-number v-model="form.priceAmountYuan" :min="0" :precision="2"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getFeeRules, addFeeRule, updateFeeRule, deleteFeeRule } from '../../api'

export default {
  name: 'FeeRuleManage',
  data() {
    return {
      query: { page: 1, pageSize: 10 },
      list: [], total: 0, loading: false,
      dialogVisible: false, isEdit: false,
      form: { id: null, ruleName: '', postType: 'SUPPLY', priceAmountYuan: 0 },
      rules: {
        ruleName: [{ required: true, message: '请输入规则名称', trigger: 'blur' }],
        postType: [{ required: true, message: '请选择帖子类型', trigger: 'change' }],
        priceAmountYuan: [{ required: true, message: '请输入费用', trigger: 'blur' }]
      },
    }
  },
  created() { this.fetchList() },
  methods: {
    fetchList() {
      this.loading = true
      getFeeRules(this.query).then(res => {
        const data = res.data || {}
        this.list = data.records || data || []
        this.total = data.total || 0
      }).finally(() => { this.loading = false })
    },
    handleAdd() {
      this.isEdit = false
      this.form = { id: null, ruleName: '', postType: 'SUPPLY', priceAmountYuan: 0 }
      this.$nextTick(() => { if (this.$refs.form) this.$refs.form.clearValidate() })
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.isEdit = true
      this.form = {
        id: row.id,
        ruleName: row.ruleName || '',
        postType: row.postType || 'SUPPLY',
        priceAmountYuan: (row.priceAmount || 0) / 100
      }
      this.$nextTick(() => { if (this.$refs.form) this.$refs.form.clearValidate() })
      this.dialogVisible = true
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const data = {
          ruleName: this.form.ruleName,
          postType: this.form.postType,
          priceAmount: Math.round(this.form.priceAmountYuan * 100)
        }
        const fn = this.isEdit ? updateFeeRule(this.form.id, data) : addFeeRule(data)
        fn.then(() => {
          this.$message.success(this.isEdit ? '修改成功' : '新增成功')
          this.dialogVisible = false
          this.fetchList()
        })
      })
    },
    handleDelete(row) {
      this.$confirm('确定要删除该规则吗？', '提示', { type: 'warning' }).then(() => {
        deleteFeeRule(row.id).then(() => { this.$message.success('已删除'); this.fetchList() })
      }).catch(() => {})
    }
  }
}
</script>
